module.exports = __webpack_public_path__ + "img/candidate-active.6da9c174.svg";